<div class="delete">
    <i class="hgi hgi-stroke hgi-cancel-01 icon icon__middle"></i>
</div>

